@if (isTabletUp()) {
  <div class="BreadcrumbsSlot">
    <sd-breadcrumbs></sd-breadcrumbs>
  </div>
} @else {
  <a [routerLink]="['/my-account']" class="mobile-breadcrumb">
    <div class="arrow-prev">
      <sd-icon [type]="iconTypes.ARROW_PREV" />
    </div>
    <span>Мой аккаунт</span>
  </a>
}
@if (isTabletUp()) {
  <div class="SideContent">
    <sd-current-profile></sd-current-profile>
    <sd-my-account-navigation></sd-my-account-navigation>
    <sd-logout-from-current-device></sd-logout-from-current-device>
    <sd-logout-from-all-devices></sd-logout-from-all-devices>
  </div>
}
<div class="BodyContent">
  <router-outlet></router-outlet>
</div>
